import { HeartHandshake } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

export default function HowItWorks({ t }) {
  return (
    <section className="border-y border-line bg-white px-5 sm:px-10 lg:px-16 py-20 sm:py-28" data-testid="how-it-works-section">
      <div className="max-w-6xl mx-auto">
        <Reveal className="max-w-2xl mb-14">
          <h2 className="font-serif tracking-tight text-3xl sm:text-4xl leading-tight mb-5">
            {t.stepsTitle} <em className="text-sage">{t.stepsAccent}</em>
          </h2>
          <p className="flex items-start gap-3 text-base leading-relaxed text-stonemute" data-testid="warmth-note">
            <HeartHandshake className="h-5 w-5 mt-1 shrink-0 text-clay" />
            {t.stepsLead}
          </p>
        </Reveal>
        <div className="grid sm:grid-cols-3 gap-10 sm:gap-8">
          {t.steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="border-t-2 border-line pt-6 group" data-testid={`step-${s.n}`}>
                <span className="font-serif text-4xl text-clay transition-transform duration-500 inline-block group-hover:-translate-y-1">{s.n}</span>
                <h3 className="font-serif text-xl sm:text-2xl font-light mt-4 mb-2.5">{s.title}</h3>
                <p className="text-sm leading-relaxed text-stonemute">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
